// helper functions for building and sending invite mails and other messages
import * as R from 'ramda'

// fallback name in case the logged in user is nameless (should not happen).
const FALLBACK_SENDER_NAME = 'EBBER Selection'

type MessageTemplate = {
  body?: string
  id?: number | string
  sender_name?: string
  subject?: string
}

type MessageCandidate = {
  name?: string
  [key: string]: unknown
}

type MessageSender = {
  first_name?: string
  last_name?: string
}

type MessageContext = Record<string, unknown>

const makeContext = R.applySpec({
  name: R.prop('name'),
  questions: R.pipe(
    R.pathOr({}, ['gma', 'answers']),
    R.keys,
    R.length,
  ),
  minutes: R.pipe(
    R.pathOr(0, ['gma', 'secondsTotal']),
    R.divide(R.__, 60),
    Math.floor,
  ),
  url: R.prop('quiz_url'),
})

const senderName = R.pipe(
  R.props(['first_name', 'last_name']),
  R.filter(R.identity),
  R.ifElse(R.length, R.join(' '), R.always(FALLBACK_SENDER_NAME)),
)

export const renderMessage = ({
  template = {},
  candidate = {},
  sender = {},
  context = {},
}: {
  candidate?: MessageCandidate
  context?: MessageContext
  sender?: MessageSender
  template?: MessageTemplate
}) => ({
  sender_name: template.sender_name || senderName(sender),
  receiver_name: candidate.name ?? '',
  subject: template.subject,
  body: R.pipe(
    makeContext,
    R.mergeLeft(context),
    renderBody(template.body || ''),
    R.trim,
  )(candidate),
  templateId: template.id,
})

export const renderBody = template => context => {
  // simple template rendering
  const replacer = (match: string, group: string) =>
    (R.prop(group, context) as string | undefined) || match
  return R.replace(/\{\{ *([^} ]+) *\}\}/g, replacer, template)
}
